import { OfferStatus } from 'types';
import { tableColumns } from '../OffersTable/tableColumns';

export const OFFER_TABS = {
  New: 'New',
  Pending: 'Pending',
  CounterReceived: 'Counter Received',
  CounterSent: 'Counter Sent',
  Upcoming: 'Upcoming',
  Accepted: 'Accepted',
  Rejected: 'Rejected',
  Expired: 'Expired',
  Withdrawn: 'Withdrawn',
  Cancelled: 'Cancelled',
  Archive: 'Archive',
};

export const emptyText = 'No Offers.';

function newOffers(offerAggregate) {
  return offerAggregate.filter((item) => !item?.LatestOfferIteration?.IsViewed);
}

function pendingOffers(offerAggregate) {
  return offerAggregate.filter(
    (item) => item.OfferStatus === OfferStatus.Pending && item?.LatestOfferIteration?.IsViewed,
  );
}

function counterReceivedOffers(offerAggregate) {
  return offerAggregate.filter(
    (item) =>
      item.OfferStatus === OfferStatus.CounterReceived && item?.LatestOfferIteration?.IsViewed,
  );
}

function counterSentOffers(offerAggregate) {
  return offerAggregate.filter(
    (item) => item.OfferStatus === OfferStatus.CounterSent && item?.LatestOfferIteration?.IsViewed,
  );
}

function acceptedOffers(offerAggregate) {
  return offerAggregate.filter(
    (item) => item.OfferStatus === OfferStatus.Accepted && item?.LatestOfferIteration?.IsViewed,
  );
}

function rejectedOffers(offerAggregate) {
  return offerAggregate
    .filter(
      (item) => item.OfferStatus === OfferStatus.Rejected && item?.LatestOfferIteration?.IsViewed,
    )
    .map((item) => ({ ...item, OfferExpiryEndDate: item?.LatestOfferIteration?.RejectedOn }));
}

function expiredOffers(offerAggregate) {
  return offerAggregate.filter(
    (item) => item.OfferStatus === OfferStatus.Expired && item?.LatestOfferIteration?.IsViewed,
  );
}

function withdrawnOffers(offerAggregate) {
  return offerAggregate.filter(
    (item) => item.OfferStatus === OfferStatus.Withdrawn && item?.LatestOfferIteration?.IsViewed,
  );
}

function cancelledOffers(offerAggregate) {
  return offerAggregate.filter(
    (item) => item.OfferStatus === OfferStatus.Cancelled && item?.LatestOfferIteration?.IsViewed,
  );
}

export const prepareOffersData = ({ offerAggregate }) => {
  return {
    newOffer: newOffers(offerAggregate),
    pending: pendingOffers(offerAggregate),
    counterReceived: counterReceivedOffers(offerAggregate),
    counterSent: counterSentOffers(offerAggregate),
    archivedOffers: {
      accepted: acceptedOffers(offerAggregate),
      rejected: rejectedOffers(offerAggregate),
      withdrawn: withdrawnOffers(offerAggregate),
      expired: expiredOffers(offerAggregate),
      cancelled: cancelledOffers(offerAggregate),
    },
  };
};
export const getArchivedOffersDetails = (archivedValue, archivedOffers) => {
  switch (archivedValue) {
    case OFFER_TABS.Accepted:
      return {
        dataSource: archivedOffers.accepted,
        columns: tableColumns(false, false, undefined, false, true, false),
      };

    case OFFER_TABS.Rejected:
      return {
        dataSource: archivedOffers.rejected,
        columns: tableColumns(false, false, undefined, true, true, false),
      };

    case OFFER_TABS.Expired:
      return {
        dataSource: archivedOffers.expired,
        columns: tableColumns(false, false, undefined, false, true, true),
      };

    case OFFER_TABS.Withdrawn:
      return {
        dataSource: archivedOffers.withdrawn,
        columns: tableColumns(false, false, undefined, false, true, false),
      };

    case OFFER_TABS.Cancelled:
      return {
        dataSource: archivedOffers.cancelled,
        columns: tableColumns(false, false, undefined, false, true, false),
      };

    default:
      return { dataSource: [], columns: [] };
  }
};

export const getArchivedOffersOptions = (archivedOffers) => {
  const { accepted, rejected, expired, withdrawn, cancelled } = archivedOffers;

  return [
    { label: OFFER_TABS.Accepted, count: accepted.length },
    { label: OFFER_TABS.Rejected, count: rejected.length },
    { label: OFFER_TABS.Expired, count: expired.length },
    { label: OFFER_TABS.Withdrawn, count: withdrawn.length },
    { label: OFFER_TABS.Cancelled, count: cancelled.length },
  ];
};
